<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <div class="center" style="overflow-y: scroll;">
        <pos-navbar #posNavbar (filterItems)="filterPostItems($event)" (filterItemsByCategory)="filterPostItemsByCategory($event)" (filterItemsByVoucherGroup)="filterPostItemsByVoucherGroup($event)" (loadVoucherGroups)="loadVoucherGroupsFromTemplates()"></pos-navbar>
        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap" *ngIf="displayProducts">
            <!-- CARD 13 -->
            <div class="card p-8" *ngFor="let product of products">
                <div class="card-preview">
                    <div class="fuse-card variable-width">
                        <div class="position-relative" (click)="addProduct(product)">
                            <div class="p-16" fxLayout="row" fxLayoutAlign="space-between start" style="text-align: center;">
                                {{product.name}}<br/><br/>
                                {{product.priceGross}} PLN
                            </div>
                        </div>

                        <div class="px-16 py-4" fxLayout="row" fxLayoutAlign="center center">
                            <button mat-icon-button aria-label="additional informations" (click)="showAdditionalProductInformationsDialog(product)">
                                <mat-icon>info</mat-icon>
                            </button>
                            <button mat-icon-button aria-label="add to card" (click)="order.addProduct(product); calculateDiscounts();">
                                <mat-icon>add_shopping_cart</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / CARD 13 -->
        </div>
        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap" *ngIf="displayVouchers">
            <!-- CARD 13 -->
            <div class="card p-8" *ngFor="let voucher of getFilteredVoucherTemplates()" style="max-width: 200px;">

                <!-- PREVIEW -->
                <div class="card-preview">
                    <div class="fuse-card variable-width">
                        <div class="position-relative">
                            <!--                            <img src="assets/images/cards/card3-square.jpg">-->
                            <!--                            <div class="position-absolute font-size-20 fuse-white-fg p-16 align-left align-bottom">-->
                            <!--                            <div class="position-absolute font-size-20 p-16 align-left align-bottom">-->
                            <!--                                {{product.name}}-->
                            <!--                            </div>-->
                            <div [ngStyle]="{background: voucher.group?voucher.group.color:'white'}" class="p-16" fxLayout="row" fxLayoutAlign="space-between start" style="text-align: center;" (click)="addVoucher(voucher)">
                                {{voucher.name}}<br/><br/>
                                {{voucher.salePrice}} PLN
                            </div>
                        </div>

                        <div class="px-16 py-4" fxLayout="row" fxLayoutAlign="center center">
                            <button mat-icon-button aria-label="additional informations" (click)="showAdditionalVoucherInformationsDialog(voucher)">
                                <mat-icon>info</mat-icon>
                            </button>
                            <button mat-icon-button aria-label="add to card" (click)="order.addVoucher(voucher); calculateDiscounts();">
                                <mat-icon>add_shopping_cart</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- / PREVIEW -->

            </div>
            <!-- / CARD 13 -->
        </div>
    </div>

    <fuse-sidebar class="sidebar" name="receipt-main-sidebar" position="right" lockedOpen="gt-md">
        <receipt-main-sidebar [newOrder]="order" [virtualReceipt]="virtualReceipt" [customer]="customer"></receipt-main-sidebar>
    </fuse-sidebar>
</div>
